import request from '@/utils/request'

export function syncState(state) {
  return request({
    url: '/auth/state',
    method: 'post',
    data: {
      state
    }
  })
}

export function getTicket(url) {
  return request({
    url: '/js_ticket?rnd=' + Math.random(),
    method: 'post',
    data: {
      url
    }
  })
}

export function userInfo() {
  return request({
    url: '/auth/session',
    method: 'post'
  })
}

export function verifyCode(data) {
  return request({
    url: '/auth/verify_code',
    method: 'post',
    data
  })
}

export function mobileBind(data) {
  return request({
    url: '/auth/mobile_bind',
    method: 'post',
    data
  })
}

/*
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post',
  })
}
*/

export function eventLTK(ltk) {
  return request({
    url: '/ltk/' + ltk,
    method: 'post'
  })
}

export function showLive(state) {
  return request({
    url: '/live/' + state,
    method: 'post',
  })
}

export function showQuestion(state) {
  return request({
    url: '/live/question/' + state,
    method: 'post',
  })
}

export function showLiveQ(state) {
  return request({
    url: '/live-q/' + state,
    method: 'post',
  })
}

export function getState(ticket) {
  return request({
    url: '/live-state/' + ticket,
    method: 'get'
  })
}


export function skipOpen(ticket) {
  return request({
    url: '/live-state/' + ticket + '/skip',
    method: 'post'
  })
}

export function putState(ticket, data) {
  return request({
    url: '/live-state/' + ticket,
    method: 'post',
    data
  })
}

export function submitAnswer(state, data) {
  return request({
    url: '/live/' + state + '/answer',
    method: 'post',
    data
  })
}


export function getRedPack(state, data) {
  return request({
    url: '/live/' + state + '/red_pack',
    method: 'post',
    data
  })
}

export function reportUploadImage() {
  return request({
    url: '/event/report/upload_image',
    method: 'post'
  })
}
export function reportFormSubmit(state, data) {
  return request({
    url: '/live/' + state + '/report',
    method: 'post',
    data
  })
}